import React from "react";
import { Card, CardContent } from "../components/ui/card";
import { Badge } from "../components/ui/badge";

const TermsOfService = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="text-center mb-12">
          <Badge className="mb-4 bg-teal-100 text-teal-800">
            Legal Agreement
          </Badge>
          <h1 className="text-4xl font-bold text-gray-900 mb-4">
            Terms of Service
          </h1>
          <p className="text-xl text-gray-600">
            Last updated: {new Date().toLocaleDateString()}
          </p>
        </div>

        <Card>
          <CardContent className="p-8 prose prose-lg max-w-none">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">Acceptance of Terms</h2>
            <p className="mb-6">
              By accessing and using FormForgePro's services, you accept and agree to be bound by the terms and provision of this agreement. These Terms of Service ("Terms") govern your use of our legal document preparation platform and services.
            </p>

            <h2 className="text-2xl font-bold text-gray-900 mb-4">Description of Service</h2>
            <p className="mb-4">FormForgePro provides:</p>
            <ul className="list-disc list-inside mb-6 space-y-2">
              <li>Automated legal document preparation across 50 US states</li>
              <li>State-specific legal forms and templates</li>
              <li>Document review and filing support services</li>
              <li>Investment and startup legal documentation</li>
              <li>Enterprise legal document management solutions</li>
            </ul>

            <h2 className="text-2xl font-bold text-gray-900 mb-4">Legal Disclaimer</h2>
            <div className="bg-yellow-50 border-l-4 border-yellow-400 p-4 mb-6">
              <p className="font-semibold text-yellow-800 mb-2">Important Legal Notice:</p>
              <p className="text-yellow-700">
                FormForgePro is NOT a law firm and does NOT provide legal advice. Our services are limited to document preparation and form completion. We recommend consulting with a qualified attorney for legal advice specific to your situation.
              </p>
            </div>

            <h2 className="text-2xl font-bold text-gray-900 mb-4">User Responsibilities</h2>
            <p className="mb-4">By using our services, you agree to:</p>
            <ul className="list-disc list-inside mb-6 space-y-2">
              <li>Provide accurate and complete information</li>
              <li>Use services only for lawful purposes</li>
              <li>Not share your account credentials</li>
              <li>Review all generated documents carefully</li>
              <li>Consult with an attorney when appropriate</li>
              <li>Comply with all applicable laws and regulations</li>
            </ul>

            <h2 className="text-2xl font-bold text-gray-900 mb-4">Payment and Billing</h2>
            <ul className="list-disc list-inside mb-6 space-y-2">
              <li>All payments are processed securely through Stripe</li>
              <li>Fees are due upon service selection and purchase</li>
              <li>Add-on services (Document Review $149, Filing Support $99) are optional</li>
              <li>Enterprise plans include 7-day trial period</li>
              <li>Refunds are provided according to our refund policy</li>
            </ul>

            <h2 className="text-2xl font-bold text-gray-900 mb-4">Intellectual Property</h2>
            <p className="mb-6">
              All content, features, and functionality on FormForgePro are owned by us and are protected by copyright, trademark, and other intellectual property laws. You may not reproduce, distribute, or create derivative works without our written permission.
            </p>

            <h2 className="text-2xl font-bold text-gray-900 mb-4">Limitation of Liability</h2>
            <div className="bg-red-50 border-l-4 border-red-400 p-4 mb-6">
              <p className="text-red-700">
                FormForgePro shall not be liable for any indirect, incidental, special, consequential, or punitive damages, including but not limited to loss of profits, data, or business opportunities, arising from your use of our services.
              </p>
            </div>

            <h2 className="text-2xl font-bold text-gray-900 mb-4">Document Accuracy</h2>
            <p className="mb-6">
              While we strive to provide accurate, up-to-date legal forms, we cannot guarantee that our documents will meet your specific needs or comply with all local requirements. Users are responsible for reviewing all documents and consulting with legal counsel when necessary.
            </p>

            <h2 className="text-2xl font-bold text-gray-900 mb-4">Privacy and Data</h2>
            <p className="mb-6">
              Your privacy is important to us. Please review our Privacy Policy to understand how we collect, use, and protect your information. By using our services, you consent to our data practices as outlined in the Privacy Policy.
            </p>

            <h2 className="text-2xl font-bold text-gray-900 mb-4">Service Availability</h2>
            <p className="mb-6">
              We strive to maintain 99.9% uptime but cannot guarantee uninterrupted service. We reserve the right to modify or discontinue services with reasonable notice.
            </p>

            <h2 className="text-2xl font-bold text-gray-900 mb-4">Termination</h2>
            <p className="mb-6">
              We may terminate or suspend your account immediately, without prior notice, for any breach of these Terms. Upon termination, your right to use the service will cease immediately.
            </p>

            <h2 className="text-2xl font-bold text-gray-900 mb-4">Governing Law</h2>
            <p className="mb-6">
              These Terms shall be governed by and construed in accordance with the laws of the State of California, without regard to its conflict of law provisions.
            </p>

            <h2 className="text-2xl font-bold text-gray-900 mb-4">Changes to Terms</h2>
            <p className="mb-6">
              We reserve the right to modify these Terms at any time. Changes will be effective immediately upon posting. Your continued use of the service after changes are posted constitutes acceptance of the new Terms.
            </p>

            <h2 className="text-2xl font-bold text-gray-900 mb-4">Contact Information</h2>
            <p className="mb-4">
              For questions about these Terms of Service, please contact us:
            </p>
            <div className="bg-gray-100 p-4 rounded-lg">
              <p className="font-semibold">FormForgePro Legal Team</p>
              <p>Email: legal@formforgepro.com</p>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default TermsOfService;